import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { EntityQueriesObject } from '../queryBase';

import { getProjectDetails } from './project';
import { GetProjectDetailsArgs, ProjectDetailsResponseDTO } from './project.types';
import { queryClient } from '../../utils/queryClient';

export const ENGAGE_PROJECT_QUERY_KEY = 'ENGAGE_PROJECT';

export const ENGAGE_PROJECT_QUERY_CONFIG = {
  staleTime: 60 * 1000,
  cacheTime: 5 * 60 * 1000,
};

type ProjectDetailsQueryArgs = Partial<GetProjectDetailsArgs> & { isPreview: boolean };

const projectQueries = {
  details: ({ participationUuid, projectUuid, isPreview }: ProjectDetailsQueryArgs) => ({
    queryKey: [ENGAGE_PROJECT_QUERY_KEY, participationUuid, projectUuid, isPreview],
    queryFn: () => {
      if ((!isPreview && !participationUuid) || !projectUuid) {
        throw new Error('Missing getProjectDetails query params.');
      }

      return getProjectDetails({ participationUuid, projectUuid });
    },
    enabled: !!(participationUuid || isPreview) && !!projectUuid,
    retry: 0,
    ...ENGAGE_PROJECT_QUERY_CONFIG,
  }),
} satisfies EntityQueriesObject;

export function useProjectDetailsQuery(
  args: ProjectDetailsQueryArgs,
): UseQueryResult<ProjectDetailsResponseDTO> {
  return useQuery(projectQueries.details(args));
}

export const getProjectDetailsCached = (
  args: ProjectDetailsQueryArgs,
): Promise<ProjectDetailsResponseDTO> => {
  return queryClient.ensureQueryData({
    queryKey: [ENGAGE_PROJECT_QUERY_KEY, args.participationUuid, args.projectUuid, args.isPreview],
    queryFn: projectQueries.details(args).queryFn,
  });
};
